import Vue from "vue";
import VueI18n from "vue-i18n";

const messages = {
  de: {
    'Ihr Suchprofil': 'Ihr Suchprofil',
    'Welche Immobilie suchen Sie?': 'Welche Immobilie suchen Sie?',
    'weiter': 'weiter',
    'zurück': 'zurück',
    'Formular abschicken': 'Formular abschicken',
    'Wohnen': 'Wohnen',
    'Gewerbe': 'Gewerbe',
    'Kaufen': 'Kaufen',
    'Mieten': 'Mieten',
    'haus': 'Haus',
    'wohnung': 'Wohnung',
    'grundstueck': 'Grundstück',
    'buero_praxis': 'Büro/Praxis',
    'einzelhandel': 'Einzelhandel',
    'hallen_lager': 'Hallen/Lager',
    'gastgewerbe': 'Gastgewerbe',
    'mehrfamilienhaus': 'Mehrfamilienhaus',
    'categoryMarketingTypeBUY': '{category} zum Kauf',
    'categoryMarketingTypeRENT': '{category} zur Miete',
    'marketingTypeBUY': 'Zum Kauf',
    'marketingTypeRENT': 'Zur Miete',
    'Kategorie': 'Kategorie',
    'Umkreis': 'Umkreis',
    'Stadt': 'Stadt',
    'Ortsteil': 'Ortsteil',
    'PLZ': 'PLZ',
    'Standort': 'Standort',
    'Straße': 'Straße',
    'Haus-Nr.': 'Haus-Nr.',
    'Anmeldung': 'Anmeldung',
    'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den': 'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den',
    'Anweisungen in der E-Mail': 'Anweisungen in der E-Mail',
    'Es ist ein Fehler aufgetreten.': 'Es ist ein Fehler aufgetreten.',
    'Bitte überprüfen Sie Ihre E-Mail-Adresse.': 'Bitte überprüfen Sie Ihre E-Mail-Adresse.',
    'Löschen': 'Löschen',
    'Bearbeiten': 'Bearbeiten',
    'Ihre gespeicherten Suchprofile': 'Ihre gespeicherten Suchprofile',
    'Suchanfragen': 'Suchanfragen',
    'Möchten Sie Ihr Suchprofil wirklich löschen?': 'Möchten Sie Ihr Suchprofil wirklich löschen?',
    'Speichern': 'Speichern',
    'Abbrechen': 'Abbrechen',
    "currencySymbol": "€",
    "wohnen": "Wohnen",
    "gewerbe": "Gewerbe",
    "kaufen": "Kaufen",
    "mieten": "Mieten",
    "fieldMin": "ab",
    "fieldMax": "bis",
    "fieldYes": "Ja",
    "fieldNo": "Nein",
    "Interessante Objekte": "Interessante Objekte ({n})",
    "Sie wurden abgemeldet": 'Sie wurden abgemeldet',
    'Seite neu laden.': 'Seite neu laden.',
    'userLogout': '{username} abmelden',
    'dataPrivacy': 'Ich habe die {link} zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten elektronisch erhoben und gespeichert werden. Hinweis: Sie können Ihre Einwilligung jederzeit widerrufen.',
    'dataPrivacyShort': 'Ich akzeptiere die {link}',
    'dataPrivacyContact': 'Ich bin einverstanden per Telefon, Brief und/oder per E-Mail kontaktiert zu werden.',
    'contactReason': 'Grund der Anfrage',
    'Ihre Nachricht': 'Mitteilung',
    'AGB': 'AGB'
  },
  en: {
    'Bitte prüfen Sie Ihre Eingaben.': 'Please check your entries.',
    'Firma': 'Company',
    'Anrede': 'Salutation',
    'Frau,Herr': 'Mrs.,Mr.',
    'Vorname': 'Firstname',
    'Nachname': 'Lastname',
    'Telefon': 'Phone',
    'E-Mail': 'Email',
    'Ihr Wunsch': 'Your request',
    'Besichtigung|besichtigung, Anruf|anruf, Weitere Details|detail': 'sightseeing|tour, call|call, further details|detail',
    'Nachricht': 'Message',
    'Ihre Nachricht wurde erfolgreich verschickt.': 'Your message was successfully sent.',
    'Anfrage senden': 'Send inquiry',
    'Ihr Weg zu uns': 'Your way to us',
    'Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.': 'Please contact us and arrange a personal meeting. We look forward to meeting you.',
    'Route jetzt berechnen': 'Calculate route now',
    'Kontaktaufnahme per:': 'Contact per:',
    'Adresse': 'Address',
    'ablehnen': 'decline',
    'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.': 'In order to design our website optimally for you and to be able to improve it continuously, we use cookies.',
    'Folgende Tools werden eingesetzt:': 'The following tools are used:',
    'Wenn Sie der Verwendung von Cookies nicht zu stimmen werden nur technisch notwendige Cookies gesetzt.': 'If you do not agree to the use of cookies, only technically necessary cookies will be set.',
    'Weitere Informationen zu Cookies erhalten Sie in unserer':'You can find further information on cookies in our',
    'Ich akzeptiere': 'I accept',
    'Die Funktion wurde deaktiviert.': 'The function has been deactivated.',
    'Wussten Sie schon?': 'Did you know?',
    'dass Sie mit einem modernen Browser deutlich schneller und sicherer unterwegs sind?': 'that you are much faster and safer with a modern browser?',
    'Zum Beispiel mit': 'For example with',
    'dataPrivacy': 'Ich habe die {link} zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten elektronisch erhoben und gespeichert werden. Hinweis: Sie können Ihre Einwilligung jederzeit widerrufen.',
    'dataPrivacyShort': 'I accept the {link}',
    'Datenschutzerklärung': 'privacy policy',
    'Ihre Nachricht': 'Message',
    'contactReason': 'Reason for request',
    'Gutscheinwert': 'Voucher amount',
    'Gutscheinempfänger': 'Voucher recipient',
    'Strasse und Hausnummer': 'Street and Housenumber',
    'Land': 'Country',
    'PLZ/Stadt': 'Zip/City',
    'dataPrivacyContact': 'Ich bin einverstanden per Telefon, Brief und/oder per E-Mail kontaktiert zu werden.',
    'Gutschein in Papierformat per Post (zzgl. 5,00 € Versandkosten)': 'Voucher in paper format by post (plus € 5.00 shipping costs)',
    'Gutschein als PDF-Datei per E-Mail': 'Voucher as PDF file by e-mail',
    'Jetzt bestellen': 'Order now',
    'AGB': 'terms and conditions',
    'Senden': 'Send',
    'Bemerkung': 'Remark'
  },
  fr: {
    'Bitte prüfen Sie Ihre Eingaben.': 'Veuillez vérifier vos saisies.',
    'Firma': 'Entreprise',
    'Anrede': 'Salutation',
    'Frau,Herr': 'Mme,M.',
    'Vorname': 'Prénom',
    'Nachname': 'Nom',
    'Telefon': 'Téléphone',
    'E-Mail': 'E-mail',
    'Ihr Wunsch': 'Votre souhait',
    'Besichtigung|besichtigung, Anruf|anruf, Weitere Details|detail': 'Visite|visite, appel|appel, Plus de détails|détail',
    'Nachricht': 'Message',
    'Ihre Nachricht wurde erfolgreich verschickt.': 'Votre message a été envoyé avec succès.',
    'Anfrage senden': 'Envoyer une demande',
    'Ihr Weg zu uns': 'Votre chemin vers nous',
    'Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.': 'N\'hésitez pas à nous contacter pour convenir d\'un entretien personnel. Nous nous réjouissons de vous rencontrer.',
    'Route jetzt berechnen': 'Calculer la route maintenant',
    'Kontaktaufnahme per:': 'Prendre contact par :',
    'Adresse': 'Adresse',
    'ablehnen': 'refuser',
    'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.': 'Nous utilisons des cookies afin d\'optimiser la conception de notre site web et de l\'améliorer en permanence.',
    'Folgende Tools werden eingesetzt:': 'Les outils suivants sont utilisés :',
    'Wenn Sie der Verwendung von Cookies nicht zu stimmen werden nur technisch notwendige Cookies gesetzt.': 'Si vous n\'acceptez pas l\'utilisation de cookies, seuls les cookies techniquement nécessaires seront installés.',
    'Weitere Informationen zu Cookies erhalten Sie in unserer':'Pour plus d\'informations sur les cookies, veuillez consulter notre',
    'Ich akzeptiere': 'J\'accepte',
    'Die Funktion wurde deaktiviert.': 'La fonction est désactivée.',
    'Wussten Sie schon?': 'Le saviez-vous ?',
    'dass Sie mit einem modernen Browser deutlich schneller und sicherer unterwegs sind?': 'qu\'un navigateur moderne vous permet de vous déplacer beaucoup plus rapidement et en toute sécurité ?',
    'Zum Beispiel mit': 'Par exemple, avec',
    'dataPrivacy': 'J\'ai pris connaissance du {link}. J\'accepte que mes indications et données soient collectées et enregistrées électroniquement. Remarque : vous pouvez révoquer votre consentement à tout moment.',
    'dataPrivacyShort': 'J\'accepte le {link}',
    'Datenschutzerklärung': 'politique de confidentialité',
    'Ihre Nachricht': 'Votre message',
    'contactReason': 'Motif de la demande',
    'Gutscheinwert': 'Valeur du bon',
    'Gutscheinempfänger': 'Bénéficiaire du bon',
    'Strasse und Hausnummer': 'Rue et numéro',
    'Land': 'Pays',
    'PLZ/Stadt': 'Code postal/Ville',
    'dataPrivacyContact': 'J\'accepte d\'être contacté(e) par téléphone, par courrier et/ou par e-mail.',
    'Gutschein in Papierformat per Post (zzgl. 5,00 € Versandkosten) (zzgl. 5,00 € Versandkosten)': 'Bon au format papier envoyé par la poste (plus 5,00 € de frais d\'envoi)',
    'Gutschein als PDF-Datei per E-Mail': 'Bon en fichier PDF par e-mail',
    'Jetzt bestellen': 'Commander maintenant',
    'AGB': 'Conditions générales',
    'Senden': 'Envoyer',
    'Bemerkung': 'Remarque'
  },
  nl: {
    'Bitte prüfen Sie Ihre Eingaben.': 'Controleer uw invoer.',
    'Firma': 'Bedrijf',
    'Anrede': 'Aanhef',
    'Frau,Herr': 'Mevrouw, De heer ',
    'Vorname': 'Voornaam',
    'Nachname': 'Achternaam',
    'Telefon': 'Telefoon',
    'E-Mail': 'E-mailadres',
    'Ihr Wunsch': 'Uw wens',
    'Besichtigung|besichtigung, Anruf|anruf, Weitere Details|detail': 'Rondleiding|tour, (aan)roep|(aan)roep, Meer details|detail',
    'Nachricht': 'Bericht',
    'Ihre Nachricht wurde erfolgreich verschickt.': 'Uw bericht is succesvol verzonden.',
    'Anfrage senden': 'Aanvraag verzenden',
    'Ihr Weg zu uns': 'Uw weg naar ons',
    'Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.': 'Neem contact met ons op en maak een afspraak voor een persoonlijk gesprek. We kijken ernaar uit u te ontmoeten.',
    'Route jetzt berechnen': 'Bereken route nu',
    'Kontaktaufnahme per:': 'Contact via:',
    'Adresse': 'Adres',
    'ablehnen': 'Weiger',
    'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.': 'Om onze website optimaal voor u te kunnen inrichten en voortdurend te verbeteren, maken wij gebruik van cookies.',
    'Folgende Tools werden eingesetzt:': 'De volgende instrumenten worden gebruikt:',
    'Wenn Sie der Verwendung von Cookies nicht zu stimmen werden nur technisch notwendige Cookies gesetzt.': 'Indien u niet instemt met het gebruik van cookies, zullen alleen technisch noodzakelijke cookies worden geplaatst.',
    'Weitere Informationen zu Cookies erhalten Sie in unserer':'Meer informatie over cookies vindt u in onze',
    'Ich akzeptiere': 'Ik accepteer',
    'Die Funktion wurde deaktiviert.': 'De functie is gedeactiveerd.',
    'Wussten Sie schon?': 'Wist je dat?',
    'dass Sie mit einem modernen Browser deutlich schneller und sicherer unterwegs sind?': 'dat u aanzienlijk sneller en veiliger bent met een moderne browser?',
    'Zum Beispiel mit': 'Bijvoorbeeld met',
    'dataPrivacy': 'Ik heb nota genomen van de {link}. Ik ga ermee akkoord dat mijn gegevens en informatie elektronisch worden verzameld en opgeslagen. Opmerking: U kunt uw toestemming op elk moment intrekken.',
    'dataPrivacyShort': 'Ik accepteer de {link}',
    'Datenschutzerklärung': 'privacyverklaring',
    'Ihre Nachricht': 'Je bericht',
    'contactReason': 'Reden voor het verzoek',
    'Gutscheinwert': 'Waarde tegoedbon',
    'Gutscheinempfänger': 'Ontvanger van de tegoedbon',
    'Strasse und Hausnummer': 'Straat en huisnummer',
    'Land': 'Land',
    'PLZ/Stadt': 'Postcode/stad',
    'dataPrivacyContact': 'Ik ga ermee akkoord dat per telefoon, brief en/of e-mail contact met mij wordt opgenomen.',
    'Gutschein in Papierformat per Post (zzgl. 5,00 € Versandkosten)': 'Tegoedbon in papieren vorm per post (plus 5,00 € verzendkosten)',
    'Gutschein als PDF-Datei per E-Mail': 'Tegoedbon als PDF per e-mail',
    'Jetzt bestellen': 'Bestel nu',
    'AGB': 'Algemene voorwaarden',
    'Senden': 'Verzenden',
    'Bemerkung': 'Commentaar'
  }
};

const numberFormats = {
  de: {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
      minimumFractionDigits: 0
    },
    decimal: {
      style: "decimal"
    },
    int: {
      style: "decimal",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      useGrouping: false
    }
  }
};

const htmlLang = document.querySelector("html").getAttribute("lang");
let locale = "de";
if (htmlLang == "en-US") {
  locale = "en";
} else if (htmlLang == "fr-FR") {
  locale = "fr";
} else if (htmlLang == "nl-NL") {
  locale = "nl";
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale,
  fallbackLocale: "de",
  messages: messages,
  numberFormats
});

export default i18n;
